import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Page } from "./types";
import MusicPlayer from "componentsTemplate/MusicPlayer/MusicPlayer";
import PageHome from "app/(home)/page";
import PageArchive from "app/(archives)/archive/page";
import PageArchiveVideo from "app/(archives)/archive-3/page";
import PageArchiveAudio from "app/(archives)/archive-2/page";
import PageAuthor from "app/author/page";
import PageSingle from "app/(singles)/(default)/single/page";
import PageSingleTemplate2 from "app/(singles)/(default)/single-2/page";
import PageSingleTemplate3 from "app/(singles)/(has-sidebar)/single-3/page";
import PageSingleGallery from "app/(singles)/(default)/single-gallery/page";
import PageSingleAudio from "app/(singles)/(default)/single-audio/page";
import PageSingleVideo from "app/(singles)/(default)/single-video/page";
import PageSearch from "app/(search)/search/page";
import PageSearchV2 from "app/(search)/search-2/page";
import PageAbout from "app/about/page";
import PageContact from "app/(others)/contact/page";
import Page404 from "app/not-found";
import PageLogin from "app/(others)/login/page";
import PageRegistration from "pages/auth/PageRegistration";
import PageForgotPass from "app/(others)/forgot-pass/page";
import PageResetPassword from "app/(others)/reset-password/page";
import PageSubcription from "app/(others)/subscription/page";
import PageHomeDemo2 from "app/(home)/home-2/page";
import PageHomeDemo3 from "app/(home)/home-3/page";
import PageHomeDemo4 from "app/(home)/home-4/page";
import PageHomeDemo6 from "app/(home)/home-6/page";
import SiteHeader from "app/SiteHeader";
import PageSingleTemplate4 from "app/(singles)/(has-sidebar)/single-4/page";
import DashboardSubmitPost from "app/(others)/dashboard/submit-post/page";
import DashboardPosts from "app/(others)/dashboard/posts/page";
import DashboardEditProfile from "app/(others)/dashboard/edit-profile/page";
import DashboardSubcription from "app/(others)/dashboard/subscription/page";
import DashboardBilingAddress from "app/(others)/dashboard/billing-address/page";
import Footer from "components/footer/Footer";

// SISTEMA
import Home from "pages/home/PageHome";
import ComingSoonPage from "pages/comingSoon/ComingSoonPage";
import EmbassadorsPage from "pages/ambassadors/ambassadors-page";
import AboutUs from "../pages/about-us/about-us";
import Planos from "../pages/planos/planos";
import PartnerCompanies from "pages/PartnerCompanies/PartnerCompanies";
import PartnersScreen from "pages/partners/partners-screen";
import Classifieds from "pages/classifieds/classifieds";
import ClassifiedDetail from "pages/classifieds/classified-detail";
import RadarSocialGeral from "pages/social/radar-social-geral";
import SocialPartners from "pages/social/social-parceiros";
import EventDetail from "pages/event-detail/EventDetail";
import Events from "pages/events/events";
import Tips from "pages/tips/tips";
import TipsWithAdvertisement from "pages/tips/tips-with-advertisement";
import TipsGeral from "pages/tips/tips-geral";
import TipsDetails from "pages/tips/tips-details";
import Contacts from "pages/contacts/contacts";
import Perfil from "pages/perfil/perfil";
import Dicas from "pages/perfil/dicas";
import Classificados from "pages/perfil/classificados";
import Parcerias from "pages/perfil/parceria";
import Eventos from "pages/perfil/eventos";
import Senha from "pages/perfil/senha";
import Contatos from "pages/perfil/contatos";

import TermsUse from "pages/terms-use/terms-use";
import PageContactRadar from "pages/contact-radar/PageContactRadar";
import UserPerfil from "pages/perfilUser/perfil";
import UserEventos from "pages/perfilUser/eventos";
import UserParcerias from "pages/perfilUser/parceria";
import UserClassificados from "pages/perfilUser/classificados";
import UserDicas from "pages/perfilUser/dicas";
import UserBasicData from "pages/perfilUser/basicData";
import Faq from "pages/faq/Faq";
import GroupCitiesMissing from "pages/group-cities/GroupCitiesMissing";
import NotAuthorization from "pages/auth/NotAuthorization";
import TipsCreateOrEdit from "pages/perfil/TipsCreateOrEdit";
import ClassifiedsCreateOrEdit from "pages/perfil/ClassifiedsCreateOrEdit";
import PartnershipsCreateOrEdit from "pages/perfil/PartnershipsCreateOrEdit";
import EventsCreateOrEdit from "pages/perfil/EventsCreateOrEdit";
import MyPlans from "pages/perfil/MyPlans";

export const pages: Page[] = [

  // SISTEMA ----------------------------------------------------------
  { path: "/", component: Home },
  { path: "/#", component: Home },
  { path: "/#beneficios", component: Home },
  { path: "/#comunidades-radar", component: Home },
  { path: "/#nosso-alcance", component: Home },
  { path: "/embaixadores", component: EmbassadorsPage },
  // { path: "/empresas-parceiras", component: PartnerCompanies },
  { path: "/quem-somos", component: AboutUs },
  { path: "/planos", component: Planos },
  { path: "/faq", component: Faq },
  { path: "/social", component: RadarSocialGeral },
  { path: "/social-parceiros/:id", component: SocialPartners },
  { path: "/evento-detalhes/:eventId", component: EventDetail },
  { path: "/eventos", component: Events },
  { path: "/dicas/:categoryId", component: TipsWithAdvertisement },
  { path: "/dicas-no-adds", component: Tips },
  { path: "/dicas-geral", component: TipsGeral },
  { path: "/dicas-detalhes/:dicaId", component: TipsDetails },
  { path: "/parceiros", component: PartnersScreen },
  { path: "/parceiros/:id", component: PartnerCompanies },
  { path: "/classificados", component: Classifieds },
  { path: "/contatos", component: Contacts },
  { path: "/perfil", component: Perfil },
  { path: "/meus-planos", component: MyPlans },

  { path: "/minhas-dicas", component: Dicas },
  { path: "/nova-dica", component: TipsCreateOrEdit },
  { path: "/editar-dica/:id", component: TipsCreateOrEdit },

  { path: "/meus-classificados", component: Classificados },
  { path: "/novo-classificado", component: ClassifiedsCreateOrEdit },
  { path: "/editar-classificado/:id", component: ClassifiedsCreateOrEdit },
  
  { path: "/minhas-parcerias", component: Parcerias },
  { path: "/nova-parceria", component: PartnershipsCreateOrEdit },
  { path: "/editar-parceria/:id", component: PartnershipsCreateOrEdit },

  { path: "/meus-eventos", component: Eventos },
  { path: "/novo-evento", component: EventsCreateOrEdit },
  { path: "/editar-evento/:id", component: EventsCreateOrEdit },

  { path: "/meus-contatos", component: Contatos },
  { path: "/fale-conosco", component: PageContactRadar },

  { path: "/senha", component: Senha },
  { path: "/forgot-pass", component: PageForgotPass },
  { path: "/reset-password", component: PageResetPassword },

  { path: "/classificados/:id", component: ClassifiedDetail },
  { path: "/dicas-no-adds", component: Tips },

  { path: "/:id/perfil", component: UserPerfil },
  { path: "/:id/contato-dicas", component: UserDicas },
  { path: "/:id/contato-classificados", component: UserClassificados },
  { path: "/:id/contato-parcerias", component: UserParcerias },
  { path: "/:id/contato-eventos", component: UserEventos },
  { path: "/:id/dados-basicos", component: UserBasicData },

  { path: "/grupo-cidades/selecionar", component: GroupCitiesMissing },
  { path: "/sem-acesso", component: NotAuthorization },
  
  // TEMPLATE ---------------------------------------------------------

  { path: "/home-1", component: PageHome },
  { path: "/home-2", component: PageHomeDemo2 },
  { path: "/home-3", component: PageHomeDemo3 },
  { path: "/home-4", component: PageHomeDemo4 },
  { path: "/home-6", component: PageHomeDemo6 },

  // auth pages ----------------------------------------------------------
  { path: "/login", component: PageLogin },
  // { path: "/email/*", component: PageLogin },

  { path: "/cadastro", component: PageRegistration },

  // archives page -------------------------------------------------------
  { path: "/archive/*", component: PageArchive },
  { path: "/archive-2/*", component: PageArchiveAudio },
  { path: "/archive-3/*", component: PageArchiveVideo },
  { path: "/author/*", component: PageAuthor },

  // single page -------------------------------------------------------
  { path: "/single/*", component: PageSingle },
  { path: "/single-2/*", component: PageSingleTemplate2 },
  { path: "/single-audio/*", component: PageSingleAudio },
  { path: "/single-video/*", component: PageSingleVideo },
  { path: "/single-gallery/*", component: PageSingleGallery },
  { path: "/single-3/*", component: PageSingleTemplate3 },
  { path: "/single-4/*", component: PageSingleTemplate4 },
  { path: "/single-5/*", component: PageSingleTemplate2 },

  // search ------------------------------------------------------------
  { path: "/search", component: PageSearch },
  { path: "/search-2", component: PageSearchV2 },

  // other pages -------------------------------------------------------
  { path: "/about", component: PageAbout },
  { path: "/contact", component: PageContact },
  { path: "/page404", component: Page404 },
  { path: "/subscription", component: PageSubcription },
  { path: "/dashboard", component: DashboardSubmitPost },
  { path: "/dashboard/posts", component: DashboardPosts },
  { path: "/dashboard/edit-profile", component: DashboardEditProfile },
  { path: "/dashboard/subscription", component: DashboardSubcription },
  { path: "/dashboard/billing-address", component: DashboardBilingAddress },
  { path: "/dashboard/submit-post", component: DashboardSubmitPost },

  { path: "/em-breve", component: ComingSoonPage },
  { path: "/termos-de-uso", component: TermsUse },
];

const MyRoutes = () => {
  const comingSoon = false; // To do: pegar esse valor do env

  return (
    <BrowserRouter>
      <SiteHeader />

      <Routes>

        {comingSoon ?
          <>
            <Route path="/em-breve" element={<ComingSoonPage />} />

            {pages.map(({ component: Component, path }, index) => {
              return <Route key={index} element={<Navigate to="/em-breve" />} path={path} />;
            })}
          </>
          :
          pages.map(({ component: Component, path }, index) => {
            return <Route key={index} element={<Component />} path={path} />;
          })
        }

        <Route path="*" element={<Page404 />} />
      </Routes>

      {!comingSoon &&
        <Footer />
      }
      <MusicPlayer />
    </BrowserRouter>
  );
};

export default MyRoutes;
